import { useContext, useEffect, useState } from "react";
import AoUrl from "../network/url";
import { $isNotNullUndefine, getCardCompany, getDateFormatted, getFirstAndLastName, isNotValidNullUndefile, isNullUndefine, isValidExpiry, userCardJson } from "../control/Constant";
import { Services } from "../network/Services";
import { runAmaSubscriptionChain, updateAmaSubscriptionAfterRecurring } from "../network/amaSubscription";
import NewPaymentModal from "./NewPaymentModal";
// import { Col, Modal, ModalFooter, Row } from "react-bootstrap";
// import { getApiCall, isNotValidNullUndefile, isNullUndefine, postApiCall, postApiCall2, recurringErrorHandled } from "../../Reusable/ReusableCom";
// import { $Service_Url } from "../../network/UrlPath";
import konsole from "../network/konsole";
// import { CustomInput } from "../../../component/Custom/CustomComponent";
// import { $AHelper } from "../../../component/Helper/$AHelper";
// import { CustomButton } from "../../../component/Custom/CustomButton";
// import AlertToaster from "../../control/AlertToaster";
// import { $JsonHelper } from "../../../component/Helper/$JsonHelper";
// import NewPaymentModal from "../../../component/Account-Settings/NewPaymentModal";
// import { useAppDispatch, useAppSelector } from "../../../component/Hooks/useRedux";
// import { selectAgreement } from "../../../component/Redux/Store/selectors";
// import { setTempData } from "../../../component/Redux/Reducers/agreementSlice";
// import { $AHelper as $oldHelper } from "../../control/AHelper";
// import Router from "next/router";
// import { globalContext } from "../../../pages/_app";
import { useConfirm } from './ConfirmationToaster';


const CardDetails = ( props ) => {
    const [loggedUserId, setloggeduserId] = useState("");
    const [showModal, setShowModal] = useState(true);
    const [userProfile, setUserProfile] = useState({});
    const [selectedCard, setSelectedcard] = useState({});
    const [cardFormData, setCardFormData] = useState({});
    // const { setWarning, confirm } = useContext(globalContext)
    // const { agreementType } = useAppSelector(selectAgreement);
    // const dispatcher = useAppDispatch();
    const confirm = useConfirm();
    const { queryData, clientData, subscriptionId, subtenantId, paymentDate, paidAmount, funForOrderIdUpdate, dispatchloader, handleIsShow, refrencePage, callerReference,isInstallmentDisbale,installmentData,selectedUserData,setInstallmentpay,setToast,setOrderIdData,resetToCompanySelection,setShowaddcard,showAddCard,userAuthSubs,formData,orderIdData,setuseLoader  } = props;

    useEffect(() => {
        // Resolve a valid userId: intake uses queryData.UserId, direct route uses the
        // selected user. queryData can be a truthy-but-empty object on the direct route,
        // so don't rely on `queryData ? ... : ...` alone (that sent `undefined`).
        const userId = queryData?.UserId || selectedUserData?.memberId || clientData?.memberId;
        fetchUserAllCards(userId);
    }, [])

    const fetchUserAllCards = async (userId) => {
        if (!userId) {
            return;
        }
        setuseLoader(true)
        let getUserProfileDetailspromise = Services.getUserProfileDetailsService(userId)
        getUserProfileDetailspromise.then((res)=>{
        setuseLoader(false)
          console.log(clientData, "fetchUserAllCards", res.data.data);
          setUserProfile(res.data.data?.[0] ?? {});
        }).catch((err)=>{
        setuseLoader(false)
            console.log(err,"fetchUserAllCardserr")
        })

    }

    const modalCLose = () => {

        // setInstallmentpay(1)
        setOrderIdData(false)
        setShowaddcard(false)
    }

    const handleChange = ( key, value ) => {
        setCardFormData({
            ...cardFormData,
            [key]: value
        })
    }

    const handleCardSelect = ( _cardDetails ) => {
        // konsole.log("dfklsjdfl", _cardDetails)
        setSelectedcard(_cardDetails);
        setCardFormData(_cardDetails);
    }

    const handleSubmit = async ( ) => {
        // if(!isValidCard()) return;
        if(isValidExpiry(cardFormData.expireDate, paymentDate) != true) {
            // giving warning to user
            // if(callerReference == "AccountSetting") setWarning("warning", "Warning", "Your card will expire before the selected future payment date. Please use a different card.");
            // else
            toasterAlert(`Your card will expire before the selected future payment date. Please use a different card.`);
            return;
        }
        const oldSameCardProfileId = userProfile?.cards?.find(ele => ele?.cardNumber == cardFormData?.cardNumber)?.paymentProfileId;
        if(isNotValidNullUndefile(oldSameCardProfileId) && (oldSameCardProfileId != cardFormData?.paymentProfileId)) return toasterAlert(
            "Card already exist."
        )
        // debugger
        let isVerified = true;
        console.log(cardFormData,"cardFormData")
        if(isNullUndefine(cardFormData?.paymentProfileId)) {
            const userRes = await confirm(
                true,
                "To add your card, we need to verify your card details. A temporary charge of $0.01 will be applied and refunded to your card within seven days. Please note that we do not store your CVV number.",
                "Confirmation",
                "custom",
                [
                    {
                        label: "Cancel",
                        value: false,
                    },
                    {
                        label: "Proceed",
                        value: true,
                    },
                ]
            );

            if(userRes != true) return;

            // formating data
            let [ _month, _year ] = cardFormData?.expireDate?.split('/');
            _year = _year?.length == 2 ? "20" + _year : _year;


            const verfiyCardJson = {
                "cardNumber": cardFormData?.cardNumber,
                "expirationDate": _year + "-" + _month, // formate must be "2030-03"
                "cardCvv": String(cardFormData?.cardCvv)
            }

            // dispatchloader(true);
            console.log(verfiyCardJson,"verfiyCardJson")
            setuseLoader(true);
            await Services.postCardVerifyService(verfiyCardJson)
                .then((res) => {
                    console.log(res, 'postCardVerifyServiceres');
                    if (res?.data != true) {
                        toasterAlert("Invalid card details. Please check your card information and try again.");
                        isVerified = false;
                    }
                })
                .catch((err) => {
                    console.log(err, "postCardVerifyServiceerr");
                    toasterAlert("Invalid card details. Please check your card information and try again.");
                    isVerified = false;
                });
            setuseLoader(false);
            // dispatchloader(false);

            // if(isVarifiedCard?.data != true) {
                // return AlertToaster.error("Invalid card details. Please check your card information and try again.")
            // }
            if (!isVerified) return;
        }

        // dispatchloader(true);
        console.log(cardFormData,"cardFormData1",clientData)

        const { firstName, lastName } = getFirstAndLastName(clientData?.fullName);
        const finalCardJson = {
            ...userCardJson(),
            ...cardFormData,

            userProfileId: cardFormData?.userProfileId ?? userProfile?.id ?? 0,
            customerProfileId: cardFormData?.customerProfileId ?? userProfile?.customerProfileId ?? "",
            userLoginId: clientData?.loginUserId ?? "",
            userId: queryData?.UserId ?? clientData?.memberId ?? "",
            emailId: clientData?.primaryEmailAddress ?? "",
            phoneNumber: clientData?.primaryPhoneNumber ?? "",
            createdBy:clientData?.memberId ?? "",

            firstName,
            lastName,

            // createdBy: '',
            updatedBy: '',
            isDefault: queryData?.paymnetFromIntake === "true" ? true : false
        }
        console.log(finalCardJson,"finalCardJson")
        setuseLoader(true)
        const postSyncUserCardInfoPromise = Services.postSyncUserCardInfoService(finalCardJson)
        setuseLoader(false)
        postSyncUserCardInfoPromise.then((res)=>{
            console.log(res,"postSyncUserCardInfores")
            let selectedcard = res?.data?.data?.cards?.filter((e)=>e?.cardNumber == cardFormData?.cardNumber)[0]
            setUserProfile(res?.data?.data ?? {});
            setSelectedcard(res?.data?.data?.cards?.find(ele => ele?.cardNumber == cardFormData?.cardNumber))
            oneTimeRecuring(res?.data?.data,selectedcard);
            handleCardSelect(res?.data?.data?.cards?.find(ele => ele?.cardNumber == cardFormData?.cardNumber))
        }).catch((err)=>{
        console.log(err,"postSyncUserCardInfoerr")
        return toasterAlert("Enter valid card details")
        })
        // dispatchloader(false);

        // if(responseData == "err") return setWarning("warning", "Warning", "Enter valid card details")
        // setUserProfile(responseData?.data?.data ?? {});
        // setSelectedcard(responseData?.data?.data?.cards?.find(ele => ele?.cardNumber == cardFormData?.cardNumber))

        // if(responseData != "err") await oneTimeRecuring(responseData?.data?.data);
        // handleCardSelect(responseData?.data?.data?.cards?.find(ele => ele?.cardNumber == cardFormData?.cardNumber))
    }


    const returnNewJson =(userById)=>{

        let stateObj={}
        // JSON.parse(sessionStorage.getItem('stateObj'));
        const {serviceName,authLength,totalOccurrence,installmentAmount,authSubsStartDate,authSubsEndDate,amount,totalDiscount,installmentDate,installmentFrequencies,installmentNumber} = props?.formData
        console.log(props?.formData,"propsformData",props,userById,"paymentProfileId",userById?.paymentProfileId)

        return  {
            "userLoginId": userById?.loggenInId || '76137',
            "userId": clientData?.memberId,
            "subscriptionName": serviceName,
            "paySchedule": { "length": installmentFrequencies == 4 ? 7 : installmentFrequencies, "unit": props?.formData?.authUnit || "days",startDate:installmentDate },
            "totalOccurrences": installmentNumber ?? 1,
            "amount": props?.installmentAmount?.toFixed(2) ?? 0,
            "customerProfileId": userById?.customerProfileId,
            "paymentProfileId": userById?.paymentProfileId,
            "cardNumber": userById?.cardNumber,
            "expirationDate": userById?.expireDate ?? '',
            "IsAuthSubsAdded" : true,
            "authSubsStartDate": installmentDate,
            "authSubsEndDate": authSubsEndDate || '',
            "paymentType": props?.paymentType || 1,
            "notes": formData?.notes || null,
            "totalAmount" :amount,
            "totalDiscount":totalDiscount || 0
             }

    }

    const recurringErrorHandled = async ( jsonBody, callNo = 1 ) => {
    setuseLoader(true)
    let resp = await Services.postApiCallNew('POST', AoUrl.post_CreateUserRecurringSubscription, jsonBody);
    setuseLoader(false)
    konsole.log("recurringErrorHandled - call no.: " + callNo + " and response", resp);
    if(resp?.isError == "true" && resp?.resPonse?.status == 404 && callNo < 5) {
    resp = await recurringErrorHandled(jsonBody, callNo + 1);
    }
    return callNo == 1 ? (resp?.isError == "true" ? "err" : resp?.resPonse) : (resp);
    }

    const oneTimeRecuring = async ( userProfileRes,selectedcard ) => {
        // alert(1)
        // return;
        // dispatchloader(true);
        let newJson ;
        // console.log(userProfileRes,"userProfileRes",selectedcard)


        // if(refrencePage == "paymentservices"){
        newJson = returnNewJson({ ...cardFormData, customerProfileId: userProfileRes?.customerProfileId, paymentProfileId: selectedcard?.paymentProfileId})
        // return;
        // }else{
        //     const subscriptionRes =  await postApiCall('GET', $Service_Url.getUserSubscription + `${subtenantId}/${true}?SubscriptionId=${subscriptionId}&UserId=${clientData?.memberId}`);
        //     // dispatchloader(false);
        //     if(!subscriptionRes?.data?.data?.[0]?.userSubscriptionId) return;

        //     const userSubscriptionId = subscriptionRes?.data?.data?.[0]?.userSubscriptionId;
        //     const paymentProfileId = userProfileRes?.cards?.find(ele => ele?.cardNumber == cardFormData?.cardNumber)?.paymentProfileId;
        //     const oneDayMilliSec = 24 * 60 * 60 * 1000;
        //     const daysDiff = Math.ceil((paymentDate - new Date()) / oneDayMilliSec);


        //     const jsonObj = $JsonHelper.createUserRecurringSubscription({
        //         ...cardFormData,
        //         userLoginId: clientData?.loginUserId,
        //         userId: clientData?.memberId,

        //         userSubscriptionId: userSubscriptionId,
        //         subscriptionId: subscriptionId,

        //         subscriptionName: "Annual Maintenance Agreement",
        //         totalOccurrences: 1,
        //         paySchedule: {
        //             length: daysDiff,
        //             unit: 'days'
        //         },
        //         amount: paidAmount,
        //         totalAmount: paidAmount ?? 0,
        //         totalDiscount: 0,
        //         orderId: null,
        //         isOneTimePay: true,

        //         customerProfileId: userProfileRes?.customerProfileId,
        //         paymentProfileId: paymentProfileId,

        //     })
        //     newJson = jsonObj
        // }

        // dispatchloader(true);

        if (queryData?.paymnetFromIntake === "true") {
        // resetToCompanySelection(userProfileRes);
        let orderId = sessionStorage.getItem('orderId')
        await props?.afterPaymentFlow(queryData?.subtenantId, userProfileRes?.userId,orderId,'SUCCESS')
        setTimeout(()=>{
        resetToCompanySelection(userProfileRes);
        },2000)
        // alert(1)
        return;
        }

        // Run the AMA subscription chain (add/update -> details -> upsert -> get -> plans)
        // BEFORE CreateUserRecurringSubscription. AMA-only (skips for other service types),
        // non-blocking. Values come from the card-save context.
        const amaUserId = clientData?.memberId || selectedUserData?.memberId || queryData?.UserId;
        // subtenantId prop is NOT passed to CardDetails on the direct route; fall back to
        // queryData (intake) and then the session SubtenantId (set at company selection).
        const amaSubtenantId = subtenantId ?? queryData?.subtenantId ?? sessionStorage.getItem('SubtenantId');
        const amaOrderId = orderIdData?.orderId || sessionStorage.getItem('orderId') || null;
        // loggedUserId state is never set in this component; use the session value.
        const amaLoggedUserId = sessionStorage.getItem('loggedUserId') || loggedUserId || null;
        const amaUserSubscriptionId = await runAmaSubscriptionChain({
          Services,
          subtenantId: amaSubtenantId,
          userId: amaUserId,
          orderId: amaOrderId,
          amount: formData?.amount ?? props?.formData?.amount ?? paidAmount, // total amount (for SKU match)
          payAmount: formData?.payAmount ?? props?.formData?.payAmount ?? paidAmount,
          responsibleAttorney: formData?.responsibleAttorney ?? props?.formData?.responsibleAttorney,
          originatingAttorney: formData?.originatingAttorney ?? props?.formData?.originatingAttorney,
          lineOfBusiness: formData?.lineOfBusiness ?? props?.formData?.lineOfBusiness,
          loggedUserId: amaLoggedUserId,
          paymentDate: formData?.paymentDate ?? props?.formData?.paymentDate ?? paymentDate,
          // Installment fields -> validityFrom = installment date, futurePayDate = next
          // installment date, totalAmount/totalPaid = per-installment amount.
          installmentDate: formData?.installmentDate ?? props?.formData?.installmentDate,
          installmentAmount: props?.installmentAmount ?? formData?.installmentAmount ?? props?.formData?.installmentAmount,
          installmentFrequencies: formData?.installmentFrequencies ?? props?.formData?.installmentFrequencies,
        });

        // Link the recurring request to the AMA subscription so the backend saves the
        // authorize ids back onto it (like the intake flow does). Without userSubscriptionId
        // + subscriptionId the backend can't attach the authorize profile ids.
        if (newJson && (Number(formData?.lineOfBusiness ?? props?.formData?.lineOfBusiness) === 1)) {
          newJson = {
            ...newJson,
            userSubscriptionId: amaUserSubscriptionId ?? 0,
            subscriptionId: 1,
            isAuthSubsAdded: true,
          };
        }

        const _resOneTimeRecurring = await recurringErrorHandled(newJson);
        if(_resOneTimeRecurring == "err") {
            // dispatchloader(false);
            let msg = refrencePage == "paymentservices" ? "Please try again after sometime" : `Unable to schedule future payment on ${!isNotValidNullUndefile(paymentDate) || NaN ? "" : getDateFormatted(paymentDate)}, Please try again after sometime`
            if(callerReference == "AccountSetting") toasterAlert(msg);
            else toasterAlert(msg);
            return;
        }else{
            // if(showAddCard == true){
                let responseData = _resOneTimeRecurring?.data?.data[0]
                // console.log(userProfileRes,"userProfileRescustomerProfileId","_resOneTimeRecurring",responseData)
                // return
                // After recurring succeeds, persist the authorize profile ids back onto
                // the AMA subscription (authorizeCustomerProfileId / PaymentProfileId /
                // SubscriptionId). AMA-only, non-blocking.
                await updateAmaSubscriptionAfterRecurring({
                  Services,
                  subtenantId: amaSubtenantId,
                  userId: amaUserId,
                  recurringData: responseData,
                  loggedUserId: amaLoggedUserId,
                });
                userAuthSubs(selectedUserData, formData, orderIdData?.orderId, 0,responseData,'payReipet')
            // }
            // setToast({message:"Thank you! Installment has been created successfully.",type: "success"})
            resetToCompanySelection()
        }

        // if(refrencePage !== "paymentservices"){
        //  const _resultPlansDetails = await getApiCall("GET", `${$Service_Url.getUserSubscriptionPlans}?UserSubscriptionId=${userSubscriptionId}&IsActive=${true}`);
        //  const dataToPassOn = {
        //     amount: paidAmount,
        //     subscriptionPlans: _resultPlansDetails,
        //     futurePayDate: $oldHelper.getFormattedDate(paymentDate),
        //     paymentProfileId: paymentProfileId,
        // }

        //     if(refrencePage == "AMA") {
        //         // debugger
        //         // dispatcher(setTempData(dataToPassOn))
        //         // redirecting to /PaymentStatus page
        //         // Router.push(`/PaymentStatus?isCallFromFuturePayment=true`);
        //     } else {
        //         funForOrderIdUpdate( undefined , true , dataToPassOn);
        //     }
        // }else{
        //     funForOrderIdUpdate();
        // }

    }





    const toasterAlert = ( text ) => setToast({ message: text, type: "error" });

    // const isValidCard = () => {
    //     const cardNumbers =  cardFormData?.cardNumber?.toString();
    //     if(isNullUndefine(cardFormData?.cardNickName) == true){
    //         toasterAlert("Please enter card holder name")
    //         return;
    //     }
    //     if(isNullUndefine(cardNumbers) == true){
    //         toasterAlert("Please enter card number")
    //         return;
    //     }
    //     if(!(cardNumbers?.length >= 14 && cardNumbers?.length <= 16)){
    //         toasterAlert("Please enter correct card number")
    //         return;
    //     }
    //     if (!$AHelper.$expiryDateValidationInput(cardFormData?.expireDate)) {
    //         toasterAlert("Please enter correct expiration date.")
    //         return;
    //     }
    //     if(isNullUndefine(cardFormData?.expireDate) == true){
    //         toasterAlert("Please enter expiration date")
    //         return;
    //     }
    //     return true;
    // }

    return (
        <>
        <div className="fixed inset-0 z-20 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white w-full max-w-4xl rounded-lg shadow-lg overflow-y-auto max-h-[90vh]">
                {/* Modal Header */}
                <div className="flex justify-between items-center p-4 border-b border-gray-200">
                    <h2 className="text-lg font-semibold">Card Details</h2>
                    <img
                        src="/closeIcon.svg"
                        className="w-5 h-5 cursor-pointer"
                        alt="Close"
                        onClick={modalCLose}
                    />
                </div>

                {/* Modal Body */}
                <div className="p-6">
                    {console.log(userProfile,"userProfile")}
                    {userProfile?.cards?.length > 0 && (
                        <>
                            <section className="mb-6">
                                <p className="font-semibold mb-4">Select your card</p>
                                <div className="space-y-2">
                                    {userProfile.cards.map(cardDetails => (
                                        <PaymentCard
                                            key={cardDetails?.cardNumber}
                                            cardDetails={cardDetails}
                                            selectedCardNum={selectedCard?.cardNumber}
                                            onSelect={handleCardSelect}
                                        />
                                    ))}
                                    <PaymentCard
                                        key={"addNewCard"}
                                        selectedCardNum={selectedCard?.cardNumber}
                                        onSelect={handleCardSelect}
                                    />
                                </div>
                                <hr className="my-6" />
                            </section>
                        </>
                    )}

                    <section>
                        <p className="font-semibold mb-4">Payment details</p>
                        <NewPaymentModal
                            formOnlyUse={true}
                            cardFormData={cardFormData}
                            setCardFormData={setCardFormData}
                            onSubmit={handleSubmit}
                            setToast={setToast}
                            useLoader={setuseLoader}
                        />
                    </section>
                </div>

                {/* Optional Footer if needed */}
                {/*
                <div className="p-4 border-t border-gray-200 flex justify-end">
                    <button
                        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                        onClick={handleSubmit}
                    >
                        Save
                    </button>
                </div>
                */}
            </div>
        </div>
        </>
    )
}

export default CardDetails;

const PaymentCard = ({ cardDetails, selectedCardNum, onSelect }) => {
    const { cardNumber, expireDate } = cardDetails ?? {};
    const last3Digit = cardNumber?.substr(cardNumber?.length - 3, 3);

    return (
        <>
        <div className="card-collection" onClick={() => onSelect(cardDetails)}>
            <div className="each-card flex w-100 space-between gap-2 text-[14px] items-center">
                <label class="radio-label custom-radio">
                    <input type="radio" checked={selectedCardNum == cardNumber} />
                    <span  className="checkmark m-0"></span>
                </label>
                {isNotValidNullUndefile(cardNumber) ? <>
                <img src="/card.png" alt="each-card-img" className="w-[54px] h-[40px] m-0 p-0" />
                <div className="m-0 p-0 items-center">
                    <p className="card-t1 font-medium m-0 p-0">{getCardCompany(cardNumber)?.cardType} ending with {last3Digit}</p>
                    <p className="card-t2 m-0 p-0">Expiry {expireDate}</p>
                </div>
                </> : <p className="card-t1 m-0 p-0">Add new payment Card</p>}
            </div>
        </div>
        </>
    )
}